export default __webpack_public_path__ + "static/media/semcasting-logo-00a9c5.70be3f96.svg";